import React from 'react';
import { RECURRENCE_LABEL } from '@/reducers/project/processes/tasks/config';
import { daysRemaining } from '@/helpers/date';
import {
  buildFilters,
  getStatusFilter,
} from '@/reducers/myTasks/myTasks.service';
import axios from '@/axiosPool';

const DEFAULT_EMPTY_VALUE = 'None';

export const mapTaskFollowers = (task) => {
  let followers = [];

  if (task.task_members && task.task_members.length) {
    followers = task.task_members
      .filter((member) => member.memberType === 'follower')
      .map((member) => ({
        userId: Number(member.user.id),
        fullName: `${member.user.firstName} ${member.user.lastName}`,
      }));
  } else if (task.followers && task.followers.length) {
    followers = task.followers.map((follower) => follower.fullName);
  }

  return followers;
};

const mapAssigneeLabel = (task) => {
  let assigneeLabel = DEFAULT_EMPTY_VALUE;

  // Support legacy prop
  if (task.assigneeId) {
    assigneeLabel = task.assigneeFullName;
  }

  if (task.assignee) {
    assigneeLabel = `${task.assignee.firstName} ${task.assignee.lastName}`;
  }

  return assigneeLabel;
};

export const mapLegacyTask = (task) => {
  const recurrenceLabel =
    task.periodType && RECURRENCE_LABEL[task.periodType]
      ? RECURRENCE_LABEL[task.periodType]
      : 'None';
  const assigneeLabel = mapAssigneeLabel(task);
  const loggedTime = task.timelogTotal
    ? task.timelogTotal.split(':').slice(0, -1).join(':')
    : '00:00';
  const followers = mapTaskFollowers(task);
  const computedDaysRemaining = daysRemaining(task.dueDate);

  for (let userId in task.followers) {
    const { firstName, lastName } = task.followers[userId];
    const follower = {
      userId: Number(userId),
      fullName: firstName + ' ' + lastName,
    };
    followers.push(follower);
  }

  return {
    ...task,
    name: task.task,
    assigneeId: task.assignedTo,
    isRecurring: !!task.periodType,
    followers: followers,
    loggedTime,
    daysRemaining: computedDaysRemaining,
    completionDate: task.dateCompleted,
    assingeeFullName: task.assigneeFullName,
    reviewerName: task.reviewerFullName || task.reviewerName,
    approverName: task.approverFullName || task.approverName,
    assigneeLabel,
    recurrenceLabel,
    workstreamName:
      task.workstreamName || (task.workstream && task.workstream.name),
    ref: React.createRef(),
    otherRef: React.createRef(),
  };
};

// Trasnform map from some legacy api props
export const transformTaskList = (taskList) => {
  return taskList.map((task) => mapLegacyTask(task));
};

export const mapCreatedTasks = (createdTasks) => {
  return createdTasks.map((task) => {
    return {
      ...task,
      task: task.name,
      assigneeFullName: task.assingeeFullName,
      approverFullName: task.approverName,
    };
  });
};

export const fetchProcessesTasksList = ({
  projectId,
  category = {},
  withCompleted,
  filters = {},
}) => {
  const url =
    category.value === 'mytasks'
      ? `api/projects/${projectId}/myTasks`
      : `api/projects/${projectId}/tasks`;

  const params = {
    filter: buildFilters({
      ...filters,
      status: getStatusFilter(withCompleted, filters.status),
    }),
    // order: JSON.stringify(order),
  };

  return axios.get(url, params).then((response) => {
    const taskList = response.data.data.map((task) => {
      const recurrenceLabel =
        task.periodType && RECURRENCE_LABEL[task.periodType]
          ? RECURRENCE_LABEL[task.periodType]
          : 'None';
      const assigneeLabel = task.assigneeId ? task.assingeeFullName : 'None';

      return {
        ...task,
        task: task.name, // PROXY for task.name for multiple references. Can this be changed directly to task.task?
        status: task.status,
        projectId,
        recurrenceLabel,
        assigneeLabel,
        ref: React.createRef(),
        otherRef: React.createRef(),
      };
    });

    return taskList;
  });
};

export const countUnassignedTasks = (list) => {
  return list.filter((t) => t.assigneeId === null).length;
};
